import zukeeper from 'zukeeper';
import {create} from 'zustand';

import {ISelect} from '../../interface/ISelect';

interface jsonStore {
  category: ISelect[] | [];
  subCategory: ISelect[] | [];
  typeOfBusiness: ISelect[] | [];
  designation: ISelect[] | [];
  gender: ISelect[] | [];
  country: any[] | [];
  holdingType: any[] | [];
  facilityType: any[] | [];
  deviceType: any[] | [];
  vehicleType: any[] | [];
  deviceFuel: any[] | [];
  fuelType: any[] | [];
  emissionSource: any[] | [];
  refridgerantType: any[] | [];
  frequency: any[] | [];
  electricBoard: any[] | [];
  waterSource: any[] | [];
  renewableType: any[] | [];
  partnerType: any[] | [];
  modeOfTransport: any[] | [];
  modeOfTransportTrav: any[] | [];
  classOfTravel: any[] | [];
  capitalGoods: any[] | [];
  propertyType: any[] | [];
  refridgentUsed: any[] | [];
  vehicleFuelUsed: any[] | [];
  states: any[] | [];
  city: any[] | [];
  wasteCategory: any[] | [];
  wasteType: any[] | [];
  preferredUnits: {};
  products: any[];
  copilotChat: any[];
  rawMaterials: any[];
  rating: any[];
  resType: any[];
  esgPillars: any[];
  esgPillarsSelectedYear: string;
  supplierType: any[];
  processType: any[];
  efdbJSON: any[];
  stackHolderTypes: any[];
  roleTypes: any[];
  accessTypes: any[];
  userGroupTypes: any[];
  activityTypes: any[];
  unitPreference: any;
  internalPermissions: any;
  externalPermissions: any;
  setCategory: (category: ISelect[]) => void;
  setUnitPreference: (unitPreference: any) => void;
  setRating: (rating: ISelect[]) => void;
  setResType: (resType: ISelect[]) => void;
  setGender: (gender: ISelect[]) => void;
  setCountry: (country: ISelect[]) => void;
  setSubCategory: (subCategory: ISelect[]) => void;
  setTypeOfBusiness: (typeOfBusiness: ISelect[]) => void;
  setDesignation: (designation: ISelect[]) => void;
  setHolding: (designation: ISelect[]) => void;
  setFacilityType: (facilityType: ISelect[]) => void;
  setDeviceType: (deviceType: ISelect[]) => void;
  setDeviceFuel: (deviceFuel: ISelect[]) => void;
  setFuelType: (fuelType: ISelect[]) => void;
  setVehicleType: (vehicleType: ISelect[]) => void;
  setEmissionSource: (emissionSource: ISelect[]) => void;
  setRefridgerantType: (refridgerantType: ISelect[]) => void;
  setFrequency: (frequency: ISelect[]) => void;
  setElectricBoard: (electricBoard: ISelect[]) => void;
  setWaterSource: (waterSource: ISelect[]) => void;
  setPreferredUnits: (preferredUnits: ISelect[]) => void;
  setRenewableType: (renewableType: ISelect[]) => void;
  setPartnerType: (partnerType: ISelect[]) => void;
  setModeOfTransport: (modeOfTransport: ISelect[]) => void;
  setModeOfTransportTrav: (modeOfTransport: ISelect[]) => void;
  setClassOfTravel: (classOfTravel: ISelect[]) => void;
  setCapitalGoods: (capitalGoods: ISelect[]) => void;
  setPropertyType: (propertyType: ISelect[]) => void;
  setRefridgentUsed: (refridgentUsed: ISelect[]) => void;
  setVehicleFuelUsed: (vehicleFuelUsed: ISelect[]) => void;
  setStates: (states: ISelect[]) => void;
  setCity: (states: ISelect[]) => void;
  setWasteCat: (wasteCategory: ISelect[]) => void;
  setWasteType: (wasteType: ISelect[]) => void;
  setProducts: (products: ISelect[]) => void;
  setCopilotChat: (copilotChat: any) => void;
  setRawMaterials: (rawMaterials: ISelect[]) => void;
  setEsgPillars: (esgPillars: any[]) => void;
  setEsgPillarsSelectedYear: (esgPillarsSelectedYear: string) => void;
  setSupplierType: (supplierType: any[]) => void;
  setProcessType: (processType: any[]) => void;
  setEfdbJSON: (processType: any[]) => void;
  setStackHolderType: (stackHolderTypes: any[]) => void;
  setRoleType: (roleType: any[]) => void;
  setAccessTypes: (accessTypes: any[]) => void;
  setUserGroupTypes: (userGroupTypes: any[]) => void;
  setActivityTypes: (activity: any[]) => void;
  setInternalPermissions: (internalPermissions: any[]) => void;
  setExternalPermissions: (externalPermissions: any[]) => void;
}

const useJSONStore = create<jsonStore>(
  zukeeper((set: any) => ({
    category: [],
    subCategory: [],
    typeOfBusiness: [],
    designation: [],
    gender: [],
    country: [],
    holdingType: [],
    facilityType: [],
    deviceFuel: [],
    deviceType: [],
    fuelType: [],
    vehicleType: [],
    emissionSource: [],
    refridgerantType: [],
    frequency: [],
    electricBoard: [],
    waterSource: [],
    renewableType: [],
    partnerType: [],
    modeOfTransport: [],
    classOfTravel: [],
    capitalGoods: [],
    propertyType: [],
    refridgentUsed: [],
    vehicleFuelUsed: [],
    modeOfTransportTrav: [],
    states: [],
    city: [],
    wasteCategory: [],
    wasteType: [],
    products: [],
    copilotChat: [],
    preferredUnits: {},
    rawMaterials: [],
    rating: [],
    resType: [],
    esgPillars: [],
    esgPillarsSelectedYear: '',
    supplierType: [],
    processType: [],
    efdbJSON: [],
    stackHolderTypes: [],
    roleTypes: [],
    accessTypes: [],
    userGroupTypes: [],
    unitPreference: {},
    activityTypes: [],
    internalPermissions: {},
    externalPermissions: {},
    setCategory: (category: ISelect[]) => {
      set(() => ({category}));
    },
    setUnitPreference: (unitPreference: ISelect[]) => {
      set(() => ({unitPreference}));
    },
    setResType: (resType: ISelect[]) => {
      set(() => ({resType}));
    },
    setRating: (rating: ISelect[]) => {
      set(() => ({rating}));
    },
    setSubCategory: (subCategory: ISelect[]) => {
      set(() => ({subCategory}));
    },
    setTypeOfBusiness: (typeOfBusiness: ISelect[]) => {
      set(() => ({typeOfBusiness}));
    },
    setDesignation: (designation: ISelect[]) => {
      set(() => ({designation}));
    },
    setGender: (gender: ISelect[]) => {
      set(() => ({gender}));
    },
    setCountry: (country: ISelect[]) => {
      set(() => ({country}));
    },
    setHolding: (holding: ISelect[]) => {
      set(() => ({holdingType: holding}));
    },
    setFacilityType: (facilityType: ISelect[]) => {
      set(() => ({facilityType}));
    },
    setDeviceType: (deviceType: ISelect[]) => {
      set(() => ({deviceType}));
    },
    setDeviceFuel: (deviceFuel: ISelect[]) => {
      set(() => ({deviceFuel}));
    },
    setFuelType: (fuelType: ISelect[]) => {
      set(() => ({fuelType}));
    },
    setVehicleType: (vehicleType: ISelect[]) => {
      set(() => ({vehicleType}));
    },
    setEmissionSource: (emissionSource: ISelect[]) => {
      set(() => ({emissionSource}));
    },
    setRefridgerantType: (refridgerantType: ISelect[]) => {
      set(() => ({refridgerantType}));
    },
    setFrequency: (frequency: ISelect[]) => {
      set(() => ({frequency}));
    },
    setElectricBoard: (electricBoard: ISelect[]) => {
      set(() => ({electricBoard}));
    },
    setWaterSource: (waterSource: ISelect[]) => {
      set(() => ({waterSource}));
    },
    setPreferredUnits: (preferredUnits: ISelect[]) => {
      set(() => ({preferredUnits}));
    },
    setRenewableType: (renewableType: ISelect[]) => {
      set(() => ({renewableType}));
    },
    setPartnerType: (partnerType: ISelect[]) => {
      set(() => ({partnerType}));
    },
    setModeOfTransport: (modeOfTransport: ISelect[]) => {
      set(() => ({modeOfTransport}));
    },
    setClassOfTravel: (classOfTravel: ISelect[]) => {
      set(() => ({classOfTravel}));
    },
    setCapitalGoods: (capitalGoods: ISelect[]) => {
      set(() => ({capitalGoods}));
    },
    setPropertyType: (propertyType: ISelect[]) => {
      set(() => ({propertyType}));
    },
    setRefridgentUsed: (refridgentUsed: ISelect[]) => {
      set(() => ({refridgentUsed}));
    },
    setVehicleFuelUsed: (vehicleFuelUsed: ISelect[]) => {
      set(() => ({vehicleFuelUsed}));
    },
    setStates: (states: ISelect[]) => {
      set(() => ({states}));
    },
    setCity: (city: ISelect[]) => {
      set(() => ({city}));
    },
    setModeOfTransportTrav: (modeOfTransportTrav: ISelect[]) => {
      set(() => ({modeOfTransportTrav}));
    },
    setWasteCat: (wasteCategory: ISelect[]) => {
      set(() => ({wasteCategory}));
    },
    setWasteType: (wasteType: ISelect[]) => {
      set(() => ({wasteType}));
    },
    setProducts: (products: ISelect[]) => {
      set(() => ({products}));
    },
    setCopilotChat: (copilotChat: ISelect[]) => {
      set(() => ({copilotChat}));
    },
    setRawMaterials: (rawMaterials: ISelect[]) => {
      set(() => ({rawMaterials}));
    },
    setEsgPillars: (esgPillars: ISelect[]) => {
      set(() => ({esgPillars}));
    },
    setEsgPillarsSelectedYear: (esgPillarsSelectedYear: string) => {
      set(() => ({esgPillarsSelectedYear}));
    },
    setSupplierType: (supplierType: string) => {
      set(() => ({supplierType}));
    },
    setProcessType: (processType: string) => {
      set(() => ({processType}));
    },
    setEfdbJSON: (efdbJSON: string) => {
      set(() => ({efdbJSON}));
    },
    setStackHolderType: (stackHolderTypes: any[]) => {
      set(() => ({stackHolderTypes}));
    },
    setRoleType: (roleTypes: any[]) => {
      set(() => ({roleTypes}));
    },
    setAccessTypes: (accessTypes: any[]) => {
      set(() => ({accessTypes}));
    },
    setUserGroupTypes: (userGroupTypes: any[]) => {
      set(() => ({userGroupTypes}));
    },
    setActivityTypes: (activityTypes: ISelect[]) => {
      set(() => ({activityTypes}));
    },
    setInternalPermissions: (internalPermissions: any) => {
      set(() => ({internalPermissions}));
    },
    setExternalPermissions: (externalPermissions: any) => {
      set(() => ({externalPermissions}));
    }
  }))
);

(window as any).store = useJSONStore;

export default useJSONStore;
